import { render, staticRenderFns } from "./home_checkbox.vue?vue&type=template&id=14cd67b8&scoped=true"
import script from "./home_checkbox.vue?vue&type=script&lang=js"
export * from "./home_checkbox.vue?vue&type=script&lang=js"
import style0 from "./home_checkbox.vue?vue&type=style&index=0&id=14cd67b8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cd67b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14cd67b8')) {
      api.createRecord('14cd67b8', component.options)
    } else {
      api.reload('14cd67b8', component.options)
    }
    module.hot.accept("./home_checkbox.vue?vue&type=template&id=14cd67b8&scoped=true", function () {
      api.rerender('14cd67b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileFormPage/home_checkbox.vue"
export default component.exports